import { useQuery } from '@tanstack/react-query';

import { fetchNightlyReports } from 'apis/hcp/reports.api';

const transformResponse = (response: {
  data: {
    reports: { report_type: string; recording: string; file: string; manual_edit: boolean }[];
  };
}) => {
  return response.data?.reports;
};

const useGetNightlyReport = (ids?: string[], original?: boolean) => {
  const {
    data: reportsList,
    isPending: reportsLoading,
    error: reportsError,
  } = useQuery({
    queryKey: ['pdf-report', ids, original],
    queryFn: ({ signal }) => fetchNightlyReports(ids, signal, original),
    select: transformResponse,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return { reportsList, reportsLoading, reportsError };
};

export default useGetNightlyReport;
